export const StorageKey: KeyedObject<string> = {
  CLIENT_ID: 'PID',
  SESSION_EXPIRE: 'SESSION_EXPIRE', // when the session expires

  DISMISSED_CONNECTION_ERROR_BANNER: 'DISMISSED_CONNECTION_ERROR_BANNER',
  RESEND_VERIFY_EMAIL_TIMEOUT: 'RESEND_VERIFY_EMAIL_TIMEOUT',
};
